export const namespace = {
  STATIONS_JSON: 'STATION_JSON',
  CONDITION_JSON: 'CONDITION_JSON',
  ORIGINAL_PROPERTIES: 'ORIGINAL_PROPERTIES',
  SELECT_STATIONS: 'SELECT_STATIONS',
  STATION_DATA: 'STATION_DATA',
  PROPERTIES: 'PROPERTIES',
  SORT_DATA: 'SORT_DATA'
}
